import { ControlledCheckbox } from "@dune/ui";
import { useFormContext } from "react-hook-form";

const SocialLandlordRentalDetailsContainer = () => {
	const { control } = useFormContext();

	return (
		<div className="flex gap-4 items-center">
			<ControlledCheckbox
				id={"socialLandlordRental"}
				control={control}
				name={"actions.socialLandlordRental"}
				label="Elle est destinée exclusivement à de la location par un bailleur social"
			/>
		</div>
	);
};

export default SocialLandlordRentalDetailsContainer;
